// extracted by mini-css-extract-plugin
module.exports = {"button":"WideButton_button__3NVYV","icon":"WideButton_icon__1AclD","span":"WideButton_span__3PBNS"};